import type { IMonthlyFinancialPositionItem } from './MonthlyFinancialPositionItem.interface';

export default class MonthlyFinancialPositionItem implements IMonthlyFinancialPositionItem {
  currentPosition: number;
  proposedPosition: number;
  proposedPositionAtBufferRate: number;
  comments: string;

  static build = (data: IMonthlyFinancialPositionItem) =>
    new MonthlyFinancialPositionItem(data);

  static blank = () => new MonthlyFinancialPositionItem();

  /**
   * Constructor
   * @param {IMonthlyFinancialPositionItem} data
   */
  constructor(data?: IMonthlyFinancialPositionItem) {
    this.currentPosition = parseFloat(data?.currentPosition || 0);
    this.proposedPosition = parseFloat(data?.proposedPosition || 0);
    this.proposedPositionAtBufferRate = parseFloat(data?.proposedPositionAtBufferRate || 0);
    this.comments = data?.comments || '';
  }
}
